import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const FUTURE_CHALLENGE_SVG = 'https://cdn.magicpatterns.com/uploads/6ikzqbMg3YKiQTBTLZDAFn/FutureChallenge.svg';
const RATHER_SAILING_SVG = 'https://cdn.magicpatterns.com/uploads/cbRmV78AWqNHmt3jUL9cbd/RatherSailing.svg';
const FCH_LOGO_WHITE = 'https://cdn.magicpatterns.com/uploads/wAdPA7wgvdq7XrQn29qvhh/FCh_logo_White.svg';
export function Hero() {
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const imageScale = 1 + scrollY * 0.0008;
  const imageTranslateY = scrollY * 0.35;
  return <section className="relative h-screen w-full overflow-hidden" data-id="element-132">
      <div className="absolute inset-0 w-full h-full" style={{
      transform: `translateY(${imageTranslateY}px) scale(${imageScale})`,
      transformOrigin: 'center center',
      transition: 'transform 0.1s ease-out',
      willChange: 'transform'
    }} data-id="element-133">
        <img src="https://cdn.magicpatterns.com/uploads/jGC4ZG2FsPpXtRMHQBJfvE/16-9-fullframe-export_(0;01;25;27)_I.jpg" alt="Flotila jachet na Jadranu" className="w-full h-full object-cover" data-id="element-134" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/35 to-black/80" data-id="element-135" />
      </div>

      {/* Logo top-left */}
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className="absolute top-4 left-4 md:top-8 md:left-8 z-10" data-id="element-136">
        <img src={FCH_LOGO_WHITE} alt="Future Challenge" width="80" height="80" className="h-12 md:h-20 w-auto block" data-id="element-137" />
      </motion.div>

      {/* Center content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-6 pt-20" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.5
      }} className="text-center flex flex-col items-center" data-id="element-139">
          {/* FUTURE CHALLENGE wordmark — clean re-exported SVG, white via filter */}
          <img src={FUTURE_CHALLENGE_SVG} alt="FUTURE CHALLENGE" className="block drop-shadow-2xl h-12 sm:h-20 md:h-28 lg:h-36 w-auto mb-24 sm:mb-32 md:mb-[300px]" style={{
          filter: 'brightness(0) invert(1)'
        }} data-id="element-140" />

          {/* "I'd rather be SAILING." tagline */}
          <motion.img initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 1,
          delay: 1
        }} src={RATHER_SAILING_SVG} alt="I'd rather be sailing" className="block drop-shadow-md h-10 sm:h-12 md:h-16 lg:h-20 w-auto" style={{
          filter: 'brightness(0) invert(1)'
        }} data-id="element-141" />

          {/* Subtitle */}
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 1,
          delay: 1.3
        }} className="font-serif-italic text-white/85 text-sm sm:text-base md:text-xl mt-6 md:mt-10 tracking-wide px-4" data-id="element-142">
            3. ročník · 15. – 22. května 2027 · Biograd na Moru
          </motion.p>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 1.5
    }} className="absolute bottom-12 left-1/2 -translate-x-1/2 z-10" data-id="element-143">
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-144">
          <ChevronDownIcon className="w-8 h-8 text-white/80" data-id="element-145" />
        </motion.div>
      </motion.div>
    </section>;
}